import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import DeliveryPromise from '../../sec_delivery-promise/component';
import KeepMePosted from '../_keep-me-posted/component';
import { Button } from 'audamatic-ui';
import Text from '@text';
import { t } from '@utils/i18n';

import './styles.scss';

const DigitalProductCTA = (props) => {
  const { product, store } = props;
  const { offered, availability, isOnline, fullProductAvailability } = product;

  const [expressOrder, setExpressOrder] = useState(false);

  const setAvailibilityText = (isExpressorder) => {
    setExpressOrder(isExpressorder);
  };
  const availibilityText = expressOrder ? t('expressorder.deliveryPromise') : fullProductAvailability;

  // Offerred 4: Only available in store, not online
  if (offered === 4) {
    return (
      <div className="pdp-primaryActions b2c offered-4">
        <DeliveryPromise offered={offered} textKey="offered.storeOnly.msg.html" showIcon />
        <Button variant="secondary" size="large" onClick={() => window.location.href = '/winkels'}>
          <Text>offered.storeOnly.button</Text>
        </Button>
      </div>
    );
  }

  // Offered 5: Out of stock, keep me posted
  if (offered === 5) {
    return (
      <div className="pdp-primaryActions b2c offered-other">
        <div className="productDetailButtons" data-test-id="comp-pdpCtaButtons">
          <KeepMePosted product={product} store={store} />
        </div>
        {availability && isOnline && (
          <DeliveryPromise offered={offered} text={fullProductAvailability} showIcon />
        )}
      </div>
    );
  }

  return (
    <div className="pdp-primaryActions b2c offered-other">
      <div className="productDetailButtons" data-test-id="comp-pdpCtaButtons">
        <AddToCartButton
          product={product}
          store={store}
          dataTestId="button-addToCart"
          showQuantity={true}
          showOrderlineReference={true}
          showExpressOrder={true}
          toggleExpressOrder={setAvailibilityText}
        />
      </div>
      {availability && isOnline && (
        <DeliveryPromise offered={offered} text={availibilityText} showIcon />
      )}
    </div>
  );
};

DigitalProductCTA.propTypes = {
  product: PropTypes.object,
  store: PropTypes.object,
};

export default DigitalProductCTA;
